// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d8ffe8b0","455":"89be5140"}[chunkId] + ".chunk.js";
};